export default __webpack_public_path__ + "static/wsp-circle-e10106c2be77494eea671175b7f2d57e.webp";